import React from 'react';
import Resident from '@components/resident';
import { ResidentPageType } from '@typings/ResidentTypes';

const AddNewResident = () => {
  return <Resident type={ResidentPageType.ADD} />;
};

export default AddNewResident;
